exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3s_hz{padding-left:0;list-style-type:none}._3-wXi{display:block;padding:6px 0;font-size:16px;color:#767676;text-decoration:none}._3-wXi:active,._3-wXi:hover{text-decoration:none;color:#484848}._3-wXi:active{font-weight:700}._34GPK{border-radius:0;width:100%;display:block;color:#484848;font-size:16px;padding-bottom:12px;border-bottom:1px solid #dce0e0}._2p1o4{margin-bottom:0;padding-left:0;list-style:none;color:#484848}._2t3-t{font-size:14px;line-height:1.43}a,a:active,a:focus,a:hover{color:#149ce9;text-decoration:none}a:active,a:focus,a:hover{cursor:pointer}._1NlsV{margin-bottom:24px}._2h6fO{margin-bottom:12px}._1wo2h{margin-top:24px}._2X_u3{margin-top:12px}._1gUWS{display:table}._1gUWS,.uRmiO{position:relative}.uRmiO{-webkit-backface-visibility:hidden;backface-visibility:hidden;display:inline-block;overflow:hidden;background-color:#bbb;border-radius:50%;border:2px solid #fff}._1ynmJ{display:table-cell}._18Jhs{border:0 none!important}._2ibrA{border-radius:0;width:100%;display:block;color:#484848;font-size:14px;line-height:1.43;padding:21px}.JJqM6{text-align:center}._2B9Tw{font-weight:700;font-family:Helvetica}._3MGew{float:left;margin-right:15px}._36Tj4{list-style:none;padding-left:0}._26ymd{display:table;width:100%}._3J8DZ{display:table-cell}._1KPnm{margin:4px 0;max-width:74px;word-wrap:break-word}._3bcjG{color:#767676}._2L36p{display:table-cell;padding-left:5px}.EFuLd{font-weight:700;color:#585858;font-family:Helvetica}._7Yw4-{color:#35baef;font-size:16px}.BGw72{position:relative;z-index:1;display:block;margin:15px 0;width:100%;color:#767676;text-align:center;font-size:14px}._1sYf1{margin-bottom:0;padding:0;list-style:none;display:table;table-layout:fixed;width:100%;font-size:inherit;border-bottom:1px solid #dce0e0}._1sYf1>li{margin-right:20px}@media screen and (max-width:480px){._1sYf1>li{margin-right:8px}}._1QOT2{display:block;padding:14px 0;position:relative;text-align:center;color:#767676;cursor:pointer;border-bottom:5px solid transparent}._1QOT2:hover{text-decoration:none;color:#484848}._3Kg3O ._1QOT2{color:#149ce9;border-color:#149ce9;text-decoration:none}._2hAIg{display:none}@media screen and (max-width:640px){._26ymd{display:block}}@media screen and (max-width:743px){._1KPnm{width:100%;max-width:100%}._1gUWS{display:block;text-align:center}._3MGew,.QLmEp{float:none}}._2rkCW{position:relative}._2rkCW li:last-child .BGw72{opacity:0;height:0;margin:0}._23xs4{padding:7px 21px;border-color:#c4c4c4;background:#fff;color:#484848;font-weight:700;font-size:14px;border-radius:0;font-family:Helvetica}._23TXK{border-color:#35baef;background-color:#35baef;color:#fff;font-family:inherit}._1KQg3{padding:9px 27px}._23TXK:active,._23TXK:active:focus,._23TXK:active:hover,._23TXK:focus,._23TXK:hover{border-color:#35baef;background-color:#35baef;color:#fff}._3gggn,._3gggn:active,._3gggn:active:focus,._3gggn:active:hover,._3gggn:focus,._3gggn:hover{border-color:#35baef;color:#35baef;background-color:#fff}.Ls0Wn{border-radius:0}._1NbgN{border-radius:4px;padding:9px 21px}._1YMTD{background:transparent!important}", ""]);

// exports
exports.locals = {
	"listContainer": "_3s_hz",
	"sideNavitem": "_3-wXi",
	"panelHeader": "_34GPK",
	"listLayout": "_2p1o4",
	"description": "_2t3-t",
	"space4": "_1NlsV",
	"space2": "_2h6fO",
	"spaceTop4": "_1wo2h",
	"spaceTop2": "_2X_u3",
	"mediaContainer": "_1gUWS",
	"profileAvatarLink": "uRmiO",
	"avatarDisplay": "_1ynmJ",
	"noBorder": "_18Jhs",
	"panelNolist": "_2ibrA",
	"textCenter": "JJqM6",
	"textBold": "_2B9Tw",
	"pullLeft": "_3MGew",
	"listStyle": "_36Tj4",
	"mediaDisplay": "_26ymd",
	"mediaDisplayCell": "_3J8DZ",
	"name": "_1KPnm",
	"reviewMuted": "_3bcjG",
	"reviewBody": "_2L36p",
	"reviewTitle": "EFuLd",
	"iconColor": "_7Yw4-",
	"horizontalLineThrough": "BGw72",
	"tabs": "_1sYf1",
	"tabItem": "_1QOT2",
	"active": "_3Kg3O",
	"showSm": "_2hAIg",
	"avatarWrapper": "QLmEp",
	"recommondations": "_2rkCW",
	"btn": "_23xs4",
	"btnPrimary": "_23TXK",
	"btnlarge": "_1KQg3",
	"btnPrimaryBorder": "_3gggn",
	"btnRadius": "Ls0Wn",
	"linkBtn": "_1NbgN",
	"noBackground": "_1YMTD"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Reviews/Reviews.css
// module id = 2563
// module chunks = 15